import { DOWNLOAD_PAYMENT_PACKAGE } from "..";
import { apiInstance } from "../config/apiInstance";
import { AxiosResponse } from "axios";

export type DownloadPaymentPackageRequest = {
  consecutive: string;
};

export const downloadPaymentPackage = async (
  data: DownloadPaymentPackageRequest,
): Promise<AxiosResponse<Blob>> => {
  const response = await apiInstance.post<Blob>(DOWNLOAD_PAYMENT_PACKAGE, data, {
    responseType: "blob",
    timeout: 0,
    headers: {
      "X-Timezone-Id": "America/Bogota",
      "Accept-Language": "es-CO",
    },
  });

  return response;
};
